<template>

  <div class="audio-div">
    <div id="vs"></div>
    <div v-if="!fromApp" class="close-icon"> <i @click.stop="closeAudio" class="iconfont icon-close-solid"></i></div>
  </div>
</template>

<script>
import 'xgplayer';
import Music from 'xgplayer-music';
export default {
  name: "AudioPreview",
  components: {

  },
  props: {
    fromApp: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
        player:undefined
    }

  },

  mounted() {
    this.initXgPlayer()
  },
  watch: {
  },
  methods: {
    initXgPlayer(url,name) {
      this.player = new Music({
        id: 'vs',
        url: [
          {
            src: url||'' ,
            name: name||'',
            poster: ''
          }
        ],
        volume: 0.5,
        height: 50,
        preloadNext: true,
        volumeShow: true,
        switchKeepProgress: false
      });
      this.player.on('complete',()=>{
         if(this.player.src){
            this.player.setIndex(0);
         }
      })


       this.player.on('timeupdate', () => {
        try {
          if(this.player.duration>0){
              this.$emit('handlerProgress',parseInt(this.player.currentTime/  this.player.duration*100));
              console.log(   this.player.duration +" =="+ this.player.currentTime + "rate:"+  this.player.currentTime/  this.player.duration*100 )
          }

      } catch (e) {
          console.log(e);
        }
      });
         this.player.on('destroy', () => {
        try {
       this.player=undefined
      } catch (e) {
          console.log(e);
        }
      })
    },
    closeAudio() {
      this.player.destroy(true);
      this.$emit('close');
    },
    playMusic(id, name, url) {
     if(this.player){
      this.setMusic(name,url)
     }else{
       this.initXgPlayer(url,name)
     }

    },
    setMusic( name, url){
      this.player.list = [];
      this.player.add({ src: url, name: name });
      this.player.setIndex(0)
      setTimeout(()=> {
        if (this.player.error) {
           console.log("音频错误提示："+this.player.error);
            this.$emit('error',  '不支持的音频格式')
            this.$emit('close');
        }
      }, 1000)
    }

  }
}
</script>

<style  scoped>
.audio-div {
  position: fixed;
  bottom: 0;
  z-index: 500;
  left: 0;
  display: flex;
  width: 100%;
}
.audio-div::v-deep .xgplayer-skin-default {
  background-color: #303233;
}
.audio-div::v-deep .xgplayer-skin-default .xgplayer-controls {
  background-image: none;
}
.audio-div::v-deep
  .xgplayer-skin-default.xgplayer-music
  .xgplayer-controls
  .xgplayer-icon {
  padding-top: 2px;
}
.audio-div::v-deep .xgplayer .xgplayer-prev .xgplayer-icon svg {
  width: 40px;
  height: 40px;
  margin: 0;
}
.audio-div::v-deep .xgplayer .xgplayer-next .xgplayer-icon svg {
  width: 40px;
  height: 40px;
  margin: 0;
}
.audio-div::v-deep
  .xgplayer-skin-default.xgplayer-music
  .xgplayer-controls
  .xgplayer-prev {
  display: none;
}
.audio-div::v-deep
  .xgplayer-skin-default.xgplayer-music
  .xgplayer-controls
  .xgplayer-next {
  display: none;
}
.audio-div::v-deep .xgplayer-skin-default.xgplayer-music .xgplayer-controls .xgplayer-play{
   margin: 1px 5px 7px 0px;
}
.audio-div::v-deep .xgplayer-skin-default .xgplayer-progress-played {
    background-image: linear-gradient(-90deg,#20CCC6,#20c4cc);
}
.audio-div::v-deep .xgplayer-skin-default .xgplayer-drag {
    background: #20CCC6;
  }

.close-icon {
  background-color: #303233;
  height: 50px;
  line-height: 50px;
  width: 60px;
  text-align: center;
}
.audio-div .close-icon i {
  color: white !important;
}
.audio-div .close-icon i:hover {
  color: #909599 !important;
}
</style>
